import { SocialMediaChannel } from '../../types/domain';

const validChannels = Object.values<string>(SocialMediaChannel);

export const isValidChannelType = (type: unknown): type is SocialMediaChannel => {
  return typeof type === 'string' && validChannels.includes(type);
};
